import { inject, Injectable } from '@angular/core';
import { PlanType } from '@pedix-workspace/utils';
import { collection } from 'firebase/firestore';
import { collectionData, FIREBASE_FIRESTORE } from '@pedix-workspace/angular-firebase';
import { map, shareReplay, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PlansService {
  planType!: PlanType;

  private firestore = inject(FIREBASE_FIRESTORE);

  private plans$ = collectionData(collection(this.firestore, 'plans'), { idField: 'id' }).pipe(
    take(1),
    map(plans => {
      const initialValue = {};
      return plans.reduce((obj: any, item: any) => {
        return {
          ...obj,
          [item['id']]: item,
        };
      }, initialValue);
    }),
    shareReplay(1),
  );

  getPlanPrices() {
    return this.plans$;
  }
}
